import {
  GETWALLETOWNERCONFIGURATIONLIST_SUCCESS,
  GETWALLETOWNERCONFIGURATIONLIST_FAILED,
  RESET_GETWALLETOWNERCONFIGURATIONLIST,
  LOADING_GETWALLETOWNERCONFIGURATIONLIST,
  NETWORK_ERROR_GETWALLETOWNERCONFIGURATIONLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetwalletownerconfigurationlist = () => {
  return { type: RESET_GETWALLETOWNERCONFIGURATIONLIST };
};

const getwalletownerconfigurationlistReq =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWALLETOWNERCONFIGURATIONLIST });
    await partnerServices
      .post(
        "getWalletOwnerConfigurationList", userData, { headers: { AuthToken: authTokenIs } }
      )
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(getwalletownerconfigurationlistSuccess(res.data));
            break;
          default:
            dispatch(getwalletownerconfigurationlistFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETWALLETOWNERCONFIGURATIONLIST,
          payload: err,
        });
      });
  };
function getwalletownerconfigurationlistSuccess(data) {
  return {
    type: GETWALLETOWNERCONFIGURATIONLIST_SUCCESS,
    payload: data,
  };
}
function getwalletownerconfigurationlistFailed(data) {
  return {
    type: GETWALLETOWNERCONFIGURATIONLIST_FAILED,
    payload: data,
  };
}

export {
  resetGetwalletownerconfigurationlist,
  getwalletownerconfigurationlistReq,
};
